var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.loaded)?_c('clinician-team-form',{attrs:{"action":_vm.action,"team":_vm.team},on:{"submitTeam":_vm.submitTeam,"cancel":_vm.cancel}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }